import { useEffect, useState } from 'react';
import axios from '../../utils/axiosConfig';
import { useParams, useNavigate } from 'react-router-dom';
import '../../styles/features/user/EditProfile.css';
import Forbidden  from '../../pages/Forbidden.js';


const EditProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [accessDenied, setAccessDenied] = useState(false);
  const [userData, setUserData] = useState({
    firstname: '',
    surname: '',
    phoneNumber: '',
    email: '',
    password: '',
    confirmPassword: '',
    birthDate: '',
    gender: 'FEMALE',
  });
  const isAdmin = userData.role === 'ADMIN';
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = localStorage.getItem("token");
    const loggedUser = JSON.parse(localStorage.getItem("user"));

    if (!token || !loggedUser) {
      navigate('/login');
      return;
    }

    if (loggedUser.role !== 'ADMIN' && loggedUser.id !== Number(id)) {
      setAccessDenied(true);
      return;
    }

    axios.get(`/customers/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => {
        const birthDate = res.data.birthDate?.slice(0, 10) || '';
        setUserData({ ...res.data, birthDate });
      })
      .catch(err => {
        console.error('Error fetching user data:', err);
        setAccessDenied(true);
      });
  }, [id, navigate]);

  if (accessDenied) return <Forbidden />;


  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const nameRegex = /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s-]{2,}$/;
    const phoneRegex = /^[0-9]{9}$/;

    if (!nameRegex.test(userData.firstname)) {
      setMessage('Firstname must be at least 2 letters long and contain only letters');
      return;
    }

    if (!nameRegex.test(userData.surname)) {
      setMessage('Surname must be at least 2 letters long and contain only letters');
      return;
    }

    if (!phoneRegex.test(userData.phoneNumber)) {
      setMessage('Phone number must be 9 digits long');
      return;
    }

    if (userData.password.length < 8) {
      setMessage('Password must be at least 8 characters long');
      return;
    }

    
    const formToSend = { ...userData };
    delete formToSend.confirmPassword;



    axios.put(`/customers/${id}`, formToSend, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
      .then(() => {
        alert('Profile updated successfully!');
        navigate(`/profile/${id}`);
      })
      .catch(err => console.error('Error updating user:', err));
  };

  return (
    <div className="edit-profile">
      <h2>Edit Your Profile Data</h2>
      <form onSubmit={handleSubmit}>
        <input name="firstname" value={userData.firstname} onChange={handleChange} placeholder="First Name" />
        <input name="surname" value={userData.surname} onChange={handleChange} placeholder="Surname" />
        <input name="phoneNumber" value={userData.phoneNumber} onChange={handleChange} placeholder="Phone Number" />
        <input name="email" type="email" value={userData.email} onChange={handleChange} placeholder="Email" />
        <input name="password" type="password" value={userData.password} onChange={handleChange} placeholder="Password" />
        <input name="confirmPassword" type="password" placeholder="Confirm Password" onChange={handleChange} required />
        {!isAdmin && (
          <>
            <input
              name="birthDate"
              type="date"
              value={userData.birthDate}
              onChange={handleChange}
            />
            <select name="gender" value={userData.gender} onChange={handleChange}>
              <option value="FEMALE">Female</option>
              <option value="MALE">Male</option>
            </select>
          </>
        )}
        <div className="button-group">
          <button type="submit" className="primary-button">Save</button>
          <button type="button" className="secondary-button" onClick={() => navigate(`/profile/${id}`)}>
            Back to profile
          </button>
        </div>
      </form>
      <p>{message}</p>
    </div>
  );
};

export default EditProfile;
